import React from "react";

import { motion } from "framer-motion";

import { useTheme } from "../../../contexts/ThemeContext";

export default function MapImage() {
  const { theme } = useTheme();

  const mainMap = {
    initial: {
      pathLength: 0,
      stroke: theme === "dark" ? "#23222a" : "#a2a2a2",
    },
    animation: {
      pathLength: 1,
      transition: {
        duration: 3,
      },
    },
  };

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 1536 1279"
      initial="initial"
      animate="animation"
      className="map-svg"
    >
      <g fill="none" stroke="#000">
        <motion.path
          variants={mainMap}
          strokeWidth="20"
          d="M-321.32 -42.798L324.29 48.302"
          transform="translate(315.31 80.198)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="20"
          d="M290.89 -15.837L275.32 102.76"
          transform="translate(391.98 10.324)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="20"
          d="M-321.32 -42.798L326.8 45.481"
          transform="translate(315.31 121.24)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="20"
          d="M208.93 470.02L276.71 -156.64"
          transform="translate(380.95 330.33)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="15"
          d="M761.79 107.32L-7.463 18.029"
          transform="translate(646.2 410.38)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="15"
          d="M761.79 107.32L-7.463 18.029"
          transform="translate(634.26 535.63)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="15"
          d="M761.79 107.32L-7.463 18.029"
          transform="translate(563.76 1084.5)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="5"
          d="M721.2 -13.545L677.55 338.6"
          transform="translate(683.29 942.08)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="15"
          d="M761.79 107.32L210.85 47.549"
          transform="translate(-216.32 1055.1)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeLinecap="round"
          strokeWidth="15"
          d="M682.58 198.28L791.71 -753.68"
          transform="translate(637.66 1083.7)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="20"
          d="M226.95 278.34L276.01 -156.29"
          transform="translate(305.36 1008.7)"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="20"
          d="M689.95 139.93c435.81 48.041 674.95 74.168 691.09 75.171s16.823 41.123-1.87 41.59-252.22-34.012-695.2-85.145"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="20"
          d="M690.37 154.787q6.29-29.352-22.745-32.175c-19.971-1.942-28.187 8.543-31.066 22.745q-4.16 20.526 21.08 30.788 28.569 4.993 32.73-21.358zM-1.819 734.15c296.86 30.932 945.74 113.45 1298.4 162.5 30.233 9.333 51.101 12.962 51.093 22.857-1.504 10.367-21.464 8.855-52.438 10.756 0 0-908.78-104.8-1298.3-149.71"
        ></motion.path>
        <motion.path
          variants={mainMap}
          strokeWidth="9"
          d="M1367.2 921.72l75.988 11.688-47.006 347.38"
        ></motion.path>
      </g>
    </motion.svg>
  );
}
